import { IconInterface } from '@veneer/core'
import React, { lazy, Suspense } from 'react'

export const Icons = {
  MinusCircle: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_minus_circle'),
  ),
  DocumentChart: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_document_chart'),
  ),
  PersonAssist: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_person_assist'),
  ),
  HandCurrency: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_hand_currency'),
  ),
  PrinterPin: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_printer_pin'),
  ),
  Scanner: lazy(() => import('@veneer/core/dist/scripts/icons/icon_scanner')),
  DocumentSignature: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_document_signature'),
  ),
  PrinterCheckmark: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_printer_checkmark'),
  ),
  DocumentScanCloud: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_document_scan_cloud'),
  ),
  Shield: lazy(() => import('@veneer/core/dist/scripts/icons/icon_shield')),
  EnvelopeOpen: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_envelope_open'),
  ),
  Envelope: lazy(() => import('@veneer/core/dist/scripts/icons/icon_envelope')),
  Cloud: lazy(() => import('@veneer/core/dist/scripts/icons/icon_cloud')),
  Circle: lazy(() => import('@veneer/core/dist/scripts/icons/icon_circle')),
  Globe: lazy(() => import('@veneer/core/dist/scripts/icons/icon_globe')),
  DashboardApplication: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_dashboard_application'),
  ),
  InkDropCheckmarkCircle: lazy(
    () =>
      import('@veneer/core/dist/scripts/icons/icon_ink_drop_checkmark_circle'),
  ),
  Bell: lazy(() => import('@veneer/core/dist/scripts/icons/icon_bell')),
  CheckCircle: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_checkmark_circle'),
  ),
  PrinterShield: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_printer_shield'),
  ),
  Link: lazy(() => import('@veneer/core/dist/scripts/icons/icon_link')),
  Person: lazy(() => import('@veneer/core/dist/scripts/icons/icon_person')),
  Download: lazy(() => import('@veneer/core/dist/scripts/icons/icon_download')),
  Key: lazy(() => import('@veneer/core/dist/scripts/icons/icon_key')),
  LockAccount: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_lock_account'),
  ),
  Building: lazy(() => import('@veneer/core/dist/scripts/icons/icon_building')),
  Checkmark: lazy(
    () => import('@veneer/core/dist/scripts/icons/icon_checkmark'),
  ),
} as const

export type VeneerIcons = keyof typeof Icons

export function VeneerIcon({
  icon,
  ...props
}: { icon: keyof typeof Icons } & IconInterface) {
  const Icon = Icons[icon]

  return (
    <Suspense fallback={<></>}>
      <Icon {...props} />
    </Suspense>
  )
}
